/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',

        'BlurAdmin.pages.dashboard',
        //'BlurAdmin.pages.ui',
        //'BlurAdmin.pages.components',
        //'BlurAdmin.pages.form',
        'BlurAdmin.pages.maps',
        'BlurAdmin.pages.charts',
        'BlurAdmin.pages.tables',
        //'BlurAdmin.pages.auth'
        //'BlurAdmin.pages.profile',
    ])
        .config(routeConfig);

    /** @ngInject */
    //function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $urlRouterProvider.otherwise('/dashboard');
        //$urlRouterProvider.otherwise('/auth');

        //$stateProvider.state('home', {
        //    url: '/',
        //    templateUrl: 'auth.html'
        //});

        //baSidebarServiceProvider.addStaticItem({
        //  title: 'Pages',
        //  icon: 'ion-document',
        //  subMenu: [{
        //    title: 'Sign In',
        //    fixedHref: 'auth.html',
        //    blank: true
        //  }, {
        //    title: 'Sign Up',
        //    fixedHref: 'reg.html',
        //    blank: true
        //  }, {
        //    title: 'User Profile',
        //    stateRef: 'profile'
        //  }, {
        //    title: '404 Page',
        //    fixedHref: '404.html',
        //    blank: true
        //  }]
        //});
        //baSidebarServiceProvider.addStaticItem({
        //  title: 'Menu Level 1',
        //  icon: 'ion-ios-more',
        //  subMenu: [{
        //    title: 'Menu Level 1.1',
        //    disabled: true
        //  }, {
        //    title: 'Menu Level 1.2',
        //    subMenu: [{
        //      title: 'Menu Level 1.2.1',
        //      disabled: true
        //    }]
        //  }]
        //});
    }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author c.polania
 * created on 26.07.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [])
      .config(routeConfig).config(amChartConfig);

  function routeConfig($stateProvider) {
      $stateProvider
          .state('charts', {
              url: '/charts',
              templateUrl: 'app/pages/charts/charts.html',
              title: 'Graficas',
              sidebarMeta: {
                  icon: 'ion-stats-bars',
                  order: 200,
              },
          });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                title: 'Dashboard',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
            });
    }

})();

/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.maps', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('maps', {
                url: '/maps',
                templateUrl: 'app/pages/maps/maps.html',
                title: 'Mapa',
                sidebarMeta: {
                    icon: 'ion-ios-location-outline',
                    order: 0,
                },
            });
    }

})();
/**
 * @author c.polania
 * created on 13.08.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          templateUrl: 'app/pages/tables/tables.html',
          title: 'Tablas',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author c.polania
 * created on 23.07.2017
 */
'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'BlurAdmin.theme',
  'BlurAdmin.pages'
])
    .service('globalFactory', function () {
        var globalDate = {};
        var globalFinalDate = {};
        var globalCliente = {};
        var globalVehiculos = {};
        var globalDatos = {};
        var estaciones = {};
        var existData = {};
        var fromMsg = {};
        var item = {};

        this.getDate = function () {
            return globalDate;
        };
        this.setDate = function (value) {
            globalDate = (value);
        };
        this.getFinalDate = function () {
            return globalFinalDate;
        };
        this.setFinalDate = function (value) {
            globalFinalDate = (value);
        };
        this.getCliente = function () {
            return globalCliente;
        }
        this.setCliente = function (value) {
            globalCliente = value;
        }
        this.getVehiculos = function () {
            return globalVehiculos;
        }
        this.setVehiculos = function (value) {
            globalVehiculos = value;
        }
        this.getDatos = function () {
            return globalDatos;
        }
        this.setDatos = function (value) {
            globalDatos = value;
        }
        this.getExistData = function () {
            return existData;
        }
        this.setExistData = function (value) {
            existData = value;
        }
        this.getFromMsg = function () {
            return fromMsg;
        }
        this.setFromMsg = function (value) {
            fromMsg = value;
        }
        this.getItem = function () {
            return item;
        }
        this.setItem = function (value) {
            item = value;
        }
        this.getEstaciones = function () {
            return estaciones;
        }
        this.setEstaciones = function (value) {
            estaciones = value;
        }

        this.setDate(formatDate(new Date()));
        this.setFromMsg(false);
        this.setItem(1);
    });

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}


//CONSTANTES
//.constant('URL_GET_LOG_ENTRIES', 'http://monitoreoapp.azurewebsites.net/api/registro');
/**
 * @author c.polania
 * created on 23.07.2017
 */
angular.module('BlurAdmin')
    .constant('constantes', {
        urlGetDashboard: 'http://monitoreoapp.azurewebsites.net/api/registro/getDashboard/1',
        urlGetByItem: 'http://monitoreoapp.azurewebsites.net/api/registro/getByItem/1/',
        urlGetItemsByUser: 'http://monitoreoapp.azurewebsites.net/api/item/getItems/1',
        urlGetByRange: 'http://monitoreoapp.azurewebsites.net/api/registro/getByItemRange/1/',
        urlGetEstaciones: 'http://monitoreoapp.azurewebsites.net/api/registro/estaciones',
        greenDot: 'assets/img/green-dot.png',
        redDot: 'assets/img/red-dot3.png',
        redCar: 'assets/img/red-car.png',
        yellowDot: 'assets/img/yellow-dot.png',
        blueDot: 'assets/img/blue-dot.png',
        orangeDot: 'assets/img/orange-dot.png',
        machin: 'assets/img/machin.png'

    });
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin')
        .factory('dataFactory', dataFactory);

    /** @ngInject */
    function dataFactory($http, $q, constantes, globalFactory) {

        var dataFactory = {};

        // Obtiene el registro mas reciente de todos los vehiculos
        dataFactory.getDashboard = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http.get(constantes.urlGetDashboard)
            .success(function (data) {
                defered.resolve(data);
            })
            .error(function (err) {
                defered.reject(err)
            });
            return promise;
        };

        dataFactory.getCustomer = function (id) {
            return $http.get(urlBase + '/' + id);
        };

        // Obtiene todos los registros filtrados por usuario, item y fecha
        dataFactory.getByItem = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http.get(constantes.urlGetByItem + globalFactory.getItem() + '/' + globalFactory.getDate())
            .success(function (data) {
                globalFactory.setExistData(true);
                defered.resolve(data);
            })
            .error(function (err) {
                globalFactory.setExistData(false);
                defered.reject(err)
            });
            return promise;
        };
        
        // Obtiene los registros filtrados por usuario, item y un rango de fecha
        dataFactory.getByRange = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http.get(constantes.urlGetByRange + globalFactory.getItem() + '/' + globalFactory.getDate() + '/' + globalFactory.getFinalDate())
                .success(function (data) {
                    globalFactory.setExistData(true);
                    defered.resolve(data);
                })
                .error(function (err) {
                    globalFactory.setExistData(false);
                    defered.reject(err)
                });
            return promise;
        };

        // Obtiene todos los items de un usuario
        dataFactory.getItemsByUser = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http.get(constantes.urlGetItemsByUser)
                .success(function (data) {
                    defered.resolve(data);
                })
                .error(function (err) {
                    defered.reject(err)
                });
            return promise;
        };

        // Obtiene las estaciones almacenadas en la BD
        dataFactory.getEstaciones = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http.get(constantes.urlGetEstaciones)
                .success(function (data) {
                    defered.resolve(data);
                })
                .error(function (err) {
                    defered.reject(err)
                });
            return promise;
        };

        return dataFactory;
    }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
      .config(config);

    /** @ngInject */
    function config(baConfigProvider, colorHelper, $provide) {
        $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
        baConfigProvider.changeTheme({ blur: true });
        //
        //baConfigProvider.changeColors({
        // default: 'rgba(#000000, 0.2)',
        // defaultText: '#ffffff',
        // dashboard: {
        //   white: '#ffffff',
        // },
        //});
    }

    /** @ngInject */
    function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
        return function (uiViewElement) {
            if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
                $anchorScroll();
            } else {
                $delegate(uiViewElement);
            }
        };
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#ffffff',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('BlurAdmin.theme')
      .constant('layoutSizes', {
          resWidthCollapseSidebar: 1200,
          resWidthHideSidebar: 500
      })
      .constant('layoutPaths', {
          images: {
              root: IMAGES_ROOT,
              profile: IMAGES_ROOT + 'app/profile/',
              amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
              amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
          }
      })
      .constant('colorHelper', {
          tint: function (color, weight) {
              return mix('#ffffff', color, weight);
          },
          shade: function (color, weight) {
              return mix('#000000', color, weight);
          },
      });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }
        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts')
        .directive('lineChart', lineChart);

    /** @ngInject */
    function lineChart() {
        return {
            restrict: 'E',
            controller: 'LineChartCtrl',
            templateUrl: 'app/pages/charts/lineChart/lineChart.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 13.08.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts')
        .controller('LineChartCtrl', LineChartCtrl);

    /** @ngInject */
    function LineChartCtrl($scope, $rootScope, baConfig, layoutPaths, globalFactory, dataFactory) {
        globalFactory.setFromMsg(false);
        var datos = [];
        var layoutColors = baConfig.colors;
        var id1 = document.getElementById('lineChart1');
        var id2 = document.getElementById('lineChart2');

        getChartService();

        //LLamada al serrvicio GET desde el factory
        function getChartService() {      
            dataFactory.getByItem()
                .then(function (response) {
                    datos = [];
                    sortData(response);
                    //Si a llamada viene desde el calendario se devuelve al otro controlador
                    if (globalFactory.getFromMsg()) {
                        $rootScope.$broadcast('postService');
                    }
                }, function (error) {
                    alert('No existen datos para la fecha seleccionada');
                    if (globalFactory.getFromMsg()) {
                        $rootScope.$broadcast('postService');
                    }
                });
        }


        //LLamada al serrvicio GET desde el factory
        function getRangeService() {
            dataFactory.getByRange()
                .then(function (response) {
                    datos = [];
                    sortData(response);
                    //Si a llamada viene desde el calendario se devuelve al otro controlador
                    if (globalFactory.getFromMsg()) {
                        $rootScope.$broadcast('postService');
                    }
                }, function (error) {
                    alert('No existen datos para la fecha seleccionada');
                    if (globalFactory.getFromMsg()) {
                        $rootScope.$broadcast('postService');
                    }
                });
        }









        function sortData(response) {
            for (var i in response) {
                if (response[i].TanqueConductor !== null && response[i].TanquePasajero !== null && response[i].Fecha !== null && response[i].Hora !== null) {
                    datos.push({
                        nivelTotal: Number(response[i].TanqueConductor) + Number(response[i].TanquePasajero),
                        fecha: response[i].Fecha,
                        hora: response[i].Hora,
                        nivel1: Number(response[i].TanqueConductor),
                        nivel2: Number(response[i].TanquePasajero),
                        date: response[i].Fecha + ' ' + response[i].Hora
                    });
                }
            }
            drawChart1();
            drawChart2();
            globalFactory.setDatos(datos);
            console.log(datos);
        }

        //function zoomChart() {
        //    lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
        //}

        function zoomChart() {
            if (chart.zoomToIndexes) {
                chart.zoomToIndexes(130, chartData.length - 1);
            }
        }

        function drawChart1() {
            var lineChart = AmCharts.makeChart(id1, {
                type: 'serial',
                theme: 'blur',
                color: layoutColors.defaultText,
                marginTop: 0,
                marginRight: 15,
                dataProvider: datos,
                precision: 2,
                valueAxes: [
                  {
                      //axisAlpha: 0,
                      position: 'left',
                      gridAlpha: 0,
                      gridColor: layoutColors.defaultText,
                      //minVerticalGap: 50,
                      color: layoutColors.defaultText,
                      axisColor: layoutColors.defaultText,
                      id: 'eje1',
                      title: 'Nivel Conductor',
                      autoGridCount: true,
                      maximum: 150,
                      minimum: 0
                  }
                ],
                graphs: [
                  {
                      id: 'g1',
                      color: layoutColors.defaultText,
                      valueAxis: 'eje1',
                      lineColor: layoutColors.danger,
                      //fillColors: layoutColors.primaryLight,
                      //fillAlphas: 0.6,
                      //lineAlpha: 0.9,
                      lineThickness: 2,
                      type: 'smoothedLine',
                      title: 'Nivel Conductor',
                      valueField: 'nivel1',
                      clustered: false,
                      //columnWidth: 5,
                      lineColorField: layoutColors.defaultText,
                      balloonText: '[[nivel1]]',
                      //bullet: 'round',
                      //bulletSize: 8,
                      negativeLineColor: layoutColors.warning
                  }
                ],
                chartScrollbar: {
                    graph: 'g1',
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    scrollbarHeight: 55,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1
                },
                chartCursor: {
                    //categoryBalloonDateFormat: 'YYYY',
                    cursorAlpha: 0,
                    valueLineEnabled: true,
                    valueLineBalloonEnabled: true,
                    valueLineAlpha: 0.5,
                    fullWidth: true,
                    categoryBalloonDateFormat: 'LL:NN A'
                },
                dataDateFormat: 'HH:mm:ss',
                categoryField: 'hora',
                categoryAxis: {
                    parseDates: true,
                    minPeriod: 'ss',
                    minorGridAlpha: 0.1,
                    minorGridEnabled: true,
                    gridAlpha: 0.5,
                    gridColor: layoutColors.border,
                    equalSpacing: false,
                },
                export: {
                    enabled: true,
                },
                creditsPosition: 'bottom-right',
                pathToImages: layoutPaths.images.amChart
            });

            lineChart.addListener('rendered', zoomChart);
            if (lineChart.zoomChart) {
                lineChart.zoomChart();
            }
        }


        function drawChart2() {
            var lineChart = AmCharts.makeChart(id2, {
                type: 'serial',
                theme: 'blur',
                color: layoutColors.defaultText,
                marginTop: 0,
                marginRight: 15,
                dataProvider: datos,
                precision: 2,
                valueAxes: [
                  {
                      //axisAlpha: 0,
                      position: 'left',
                      gridAlpha: 0,
                      gridColor: layoutColors.defaultText,
                      //minVerticalGap: 50,
                      color: layoutColors.defaultText,
                      axisColor: layoutColors.defaultText,
                      id: 'eje1',
                      title: 'Nivel Pasajero',
                      autoGridCount: true,
                      maximum: 150,
                      minimum: 0
                  }
                ],
                graphs: [
                  {
                      id: 'g1',
                      color: layoutColors.defaultText,
                      valueAxis: 'eje1',
                      lineColor: layoutColors.danger,
                      //fillColors: layoutColors.primaryLight,
                      //fillAlphas: 0.6,
                      //lineAlpha: 0.9,
                      lineThickness: 2,
                      type: 'smoothedLine',
                      title: 'Nivel Conductor',
                      valueField: 'nivel2',
                      clustered: false,
                      //columnWidth: 5,
                      lineColorField: layoutColors.defaultText,
                      balloonText: '[[nivel2]]',
                      //bullet: 'round',
                      //bulletSize: 8,
                      negativeLineColor: layoutColors.warning
                  }
                ],
                chartScrollbar: {
                    graph: 'g1',
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    scrollbarHeight: 55,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1
                },
                chartCursor: {
                    //categoryBalloonDateFormat: 'YYYY',
                    cursorAlpha: 0,
                    valueLineEnabled: true,
                    valueLineBalloonEnabled: true,
                    valueLineAlpha: 0.5,
                    fullWidth: true,
                    categoryBalloonDateFormat: 'LL:NN A'
                },
                dataDateFormat: 'HH:mm',
                categoryField: 'hora',
                categoryAxis: {
                    parseDates: true,
                    minPeriod: 'hh',
                    minorGridAlpha: 0.1,
                    minorGridEnabled: true,
                    gridAlpha: 0.5,
                    gridColor: layoutColors.border,
                    equalSpacing: false,
                },
                export: {
                    enabled: true
                },
                creditsPosition: 'bottom-right',
                pathToImages: layoutPaths.images.amChart
            });

            //lineChart.addListener('rendered', zoomChart);
            lineChart.addListener("dataUpdated", zoomChart);

            if (lineChart.zoomChart) {
                lineChart.zoomChart();
            }
        }

        //Listener del broadcast desde msgCtrl
        $scope.$on('chartClick', function (event) {
            getChartService();
        });

        //Listener del broadcast desde msgCtrl Rango
        $scope.$on('chartRangeClick', function (event) {
            getRangeService();
        });

    }
})();

/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardBlock', dashboardBlock);

  /** @ngInject */
  function dashboardBlock() {
    return {
      restrict: 'E',
      controller: 'DashboardBlockCtrl',
      templateUrl: 'app/pages/dashboard/dashboardBlock/dashboardBlock.html'
    };
  }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardBlockCtrl', DashboardBlockCtrl);

    /** @ngInject */
    function DashboardBlockCtrl($scope, baConfig) {
        //$scope.nombre = globalFactory.getDatos()[0][0].name + ' ' + globalFactory.getDatos()[0][0].lastname;
        var fecha = $scope.truck.Fecha + ' ' + $scope.truck.Hora;
        $scope.nivelTotal = ($scope.truck.TanqueConductor + $scope.truck.TanquePasajero).toFixed(1);
        //var labelSet = [];
        //labelSet.push('Tanque Conductor');
        //labelSet.push('Tanque Pasajero');
        //labelSet.push('Tanque Libre');
        //labelSet.push('Capacidad 120gal');
        //labelSet.push($scope.nombre);
        //labelSet.push('Ubicacion');
        //labelSet.push(fecha);       
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardFuelGauge', dashboardFuelGauge);

    /** @ngInject */
    function dashboardFuelGauge() {
        return {
            restrict: 'E',
            controller: 'DashboardFuelGaugeCtrl',
            templateUrl: 'app/pages/dashboard/dashboardFuelGauge/dashboardFuelGauge.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardFuelGaugeCtrl', DashboardFuelGaugeCtrl);

    /** @ngInject */
    function DashboardFuelGaugeCtrl($scope, $timeout, baConfig) {
        var layoutColors = baConfig.colors;
        var chart;
        var arrow;
        var axis;

        var nivel1 = $scope.truck.TanqueConductor;
        var nivel2 = $scope.truck.TanquePasajero;

        $scope.gauges = [{
            description: 'T. Conductor',
            level: nivel1
        }, {
            description: 'T. Pasajero',
            level: nivel2
        }
        ];

        function drawGauge1() {
            var gaugeChart1 = AmCharts.makeChart('object1-' + $scope.truck.IdItem, {
                "type": "gauge",
                "marginBottom": 0,
                "marginTop": 0,
                "theme": "light",
                "axes": [{
                    "labelsEnabled": false,
                    "startAngle": -45,
                    "endAngle": 45,
                    "axisThickness": 1,
                    "axisAlpha": 0.2,
                    "tickAlpha": 0.8,
                    "valueInterval": 40,
                    "bands": [{
                        "color": "#cc4748",
                        "endValue": 40,
                        "startValue": 0,
                        "innerRadius": "90%",
                    }, {
                        "color": "#ffffff",
                        "endValue": 120,
                        "startValue": 40
                    }],
                    "bottomText": "0 Gal",
                    "bottomTextYOffset": -20,
                    "endValue": 120
                }],
                "arrows": [{
                    "alpha": 1,
                    "borderAlpha": 0,
                    "color": "#FF8000",
                    "nailAlpha": 0,
                    "id": "GaugeArrow-1",
                    "innerRadius": 0,
                    "startWidth": 5
                }],
                "export": {
                    "enabled": true
                }
            });

            setInterval(randomValue1(gaugeChart1), 2000);
        }

        function drawGauge2() {
            var gaugeChart2 = AmCharts.makeChart('object2-' + $scope.truck.IdItem, {
                "type": "gauge",
                "marginBottom": 0,
                "marginTop": 0,
                "theme": "light",
                "axes": [{
                    "labelsEnabled": false,
                    "startAngle": -45,
                    "endAngle": 45,
                    "axisThickness": 1,
                    "axisAlpha": 0.2,
                    "tickAlpha": 0.8,
                    "valueInterval": 40,
                    "bands": [{
                        "color": "#cc4748",
                        "endValue": 40,
                        "startValue": 0,
                        "innerRadius": "90%",
                    }, {
                        "color": "#ffffff",
                        "endValue": 120,
                        "startValue": 40
                    }],
                    "bottomText": "0 Gal",
                    "bottomTextYOffset": -20,
                    "endValue": 120
                }],
                "arrows": [{
                    "alpha": 1,
                    "borderAlpha": 0,
                    "color": "#FF8000",
                    "nailAlpha": 0,
                    "id": "GaugeArrow-1",
                    "innerRadius": 0,
                    "startWidth": 5
                }],
                "export": {
                    "enabled": true
                }
            });

            setInterval(randomValue2(gaugeChart2), 2000);
        }

        // set random value
        function randomValue1(gaugeChart) {
            if (gaugeChart) {
                if (gaugeChart.arrows) {
                    if (gaugeChart.arrows[0]) {
                        if (gaugeChart.arrows[0].setValue) {
                            gaugeChart.arrows[0].setValue(nivel1);
                            gaugeChart.axes[0].setBottomText(nivel1 + " Gal");
                        }
                    }
                }
            }
        }

        // set random value
        function randomValue2(gaugeChart) {
            if (gaugeChart) {
                if (gaugeChart.arrows) {
                    if (gaugeChart.arrows[0]) {
                        if (gaugeChart.arrows[0].setValue) {
                            gaugeChart.arrows[0].setValue(nivel2);
                            gaugeChart.axes[0].setBottomText(nivel2 + " Gal");
                        }
                    }
                }
            }
        }

        $timeout(function () {
            drawGauge1();
            drawGauge2();
        }, 10);
    }

})();

/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardMap', dashboardMap);

    /** @ngInject */
    function dashboardMap() {
        return {
            restrict: 'E',
            controller: 'DashboardMapCtrl',
            templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardMapCtrl', DashboardMapCtrl);

    function DashboardMapCtrl($http, $scope, globalFactory, dataFactory, constantes) {

        $scope.info;
        getDashboard();

        getEstaciones();

        function getDashboard() {
            dataFactory.getDashboard()
                .then(function (response) {
                    $scope.info = response;
                    //globalFactory.setVehiculos(response);
                    drawMap(response[1]);
                }, function (error) {
                    $scope.status = 'Unable to load customer data: ' + error.message;
                });
        }

        function getEstaciones() {
            dataFactory.getEstaciones()
                .then(function (response) {
                    globalFactory.setEstaciones(response);
                }, function (error) {
                    $scope.status = 'Unable to load stations from DB: ' + error.message;
                });
        }

        function drawMap(vehiculos) {
            var map = new google.maps.Map(document.getElementById('amChartMap'), {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                //zoom: 2
            });
            var markerBounds = new google.maps.LatLngBounds();
            for (var i = 0; i < vehiculos.length; i++) {
                var locationPoint = new google.maps.LatLng(vehiculos[i].Latitud, vehiculos[i].Longitud);
                new google.maps.Marker({
                    position: locationPoint,
                    map: map,
                    title: "Placa: " + vehiculos[i].Placa + "\n" + "Tanque C: " + vehiculos[i].TanqueConductor +
                    "\n" + "Tanque P: " + vehiculos[i].TanquePasajero + "\n" + "Fecha: " + vehiculos[i].Fecha +
                    "\n" + "Hora: " + vehiculos[i].Hora,
                    animation: google.maps.Animation.DROP,
                    label: vehiculos[i].Placa
                });
                markerBounds.extend(locationPoint);
            }
            //map.fitBounds(markerBounds);

            // Adicionar las marcas de las estaciones
            var image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
            

            for (var j = 0; j < globalFactory.getEstaciones().length; j++){
                if (globalFactory.getEstaciones()[j].Latitud != null) {
                    var stationPoint = new google.maps.LatLng(globalFactory.getEstaciones()[j].Latitud, globalFactory.getEstaciones()[j].Longitud);
                    new google.maps.Marker({
                        position: stationPoint,
                        map: map,
                        //label: globalFactory.getEstaciones()[j].Campo,
                        icon: constantes.machin
                    });
                    //stationMarker.setPosition(stationPoint);
                    markerBounds.extend(stationPoint);
                    console.log(globalFactory.getEstaciones()[j].Latitud + ' - ' +  globalFactory.getEstaciones()[j].Longitud);
                }
            }
            console.log(markerBounds);
            map.fitBounds(markerBounds);
            
        }

    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
        var nivel1 = $scope.truck.TanqueConductor;
        var nivel2 = $scope.truck.TanquePasajero;
        var totalCom = (nivel1 + nivel2).toFixed(1);
        var percentage = 100;
        var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
        $scope.charts = [{
            color: pieColor,
            description: 'T. Conductor',
            stats: nivel1,
            capacidad: '120 gal.',//truck.capacity
            percent: getPercentage(nivel1)
        }, {
            color: pieColor,
            description: 'T. Pasajero',
            stats: nivel2,
            capacidad: '120 gal.',
            percent: getPercentage(nivel2)
        }//, {
        //    color: pieColor,
        //    description: 'Total',
        //    stats: totalCom,
        //    capacidad: '240 gal.',
        //    percent: getPercentage(totalCom/2)
        //}
        ];

        function getPercentage(currentValue) {
            percentage = Math.round((currentValue * 100) / 120);//aqui se divide por truck.capacity...
            return percentage;
        }

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round',
                });
            });

            $('.refresh-data').on('click', function () {
                updatePieCharts();
            });
        }

        function updatePieCharts() {
            $('.pie-charts .chart').each(function (index, chart) {
                if (index == 0)
                    $(chart).data('easyPieChart').update(getPercentage(nivel1));//aqui pasar valor recibido del serv. $rootScope.trucks[n].tanqueConductor
                if (index == 1)
                    $(chart).data('easyPieChart').update(getPercentage(nivel2));//aqui pasar valor recibido del serv. $rootScope.trucks[n].tanquePasajero
                //if (index == 2)
                //    $(chart).data('easyPieChart').update(getPercentage(totalCom / 2));
            });
        }

        $timeout(function () {
            loadPieCharts();
            updatePieCharts();
        }, 1000);
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardSpeedGauge', dashboardSpeedGauge);

    /** @ngInject */
    function dashboardSpeedGauge() {
        return {
            restrict: 'E',
            controller: 'DashboardSpeedGaugeCtrl',
            templateUrl: 'app/pages/dashboard/dashboardSpeedGauge/dashboardSpeedGauge.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardSpeedGaugeCtrl', DashboardSpeedGaugeCtrl);

    /** @ngInject */
    function DashboardSpeedGaugeCtrl($timeout, $http, $scope) {
        function initialize() {
            var gaugeSpeedChart;

            drawSpeedGauge();

            function drawSpeedGauge() {
                gaugeSpeedChart = AmCharts.makeChart($scope.truck.IdItem, {
                    "type": "gauge",
                    "marginBottom": 0,
                    "marginTop": 0,
                    "theme": "light",
                    "axes": [{
                        "axisThickness": 1,
                        "axisAlpha": 0.2,
                        "tickAlpha": 0.8,
                        "valueInterval": 10,
                        "bands": [{
                            "color": "#84b761",
                            "endValue": 120,
                            "startValue": 80
                        }, {
                            "color": "#fdd400",
                            "endValue": 80,
                            "startValue": 40
                        }, {
                            "color": "#cc4748",
                            "endValue": 40,
                            "startValue": 0
                        }],
                        "bottomText": $scope.truck.Velocidad + " Km/h",
                        "bottomTextYOffset": 0,
                        "endValue": 120
                    }],
                    "arrows": [{
                        "value": $scope.truck.Velocidad
                            }],
                    "export": {
                        "enabled": true
                    }
                });
            }
        }

        $timeout(function () {
            initialize();
        }, 500);
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('TrafficChartCtrl', TrafficChartCtrl);

    /** @ngInject */
    function TrafficChartCtrl($scope, $timeout, baConfig, layoutPaths, globalFactory) {

        $scope.nivelTotal = ($scope.truck.nivel1 + $scope.truck.nivel2).toFixed(1);

        var graphData = [];
        graphData.push({ label: 'Tanque Conductor', level: $scope.truck.nivel1 });
        graphData.push({ label: 'Tanque Pasajero', level: $scope.truck.nivel2 });
        graphData.push({ label: 'Tanque Libre', level: $scope.nivelTotal });

        $scope.transparent = baConfig.theme.blur;
        var dashboardColors = baConfig.colors.dashboard;
        var layoutColors = baConfig.colors;

        //obtener ubicacion
        //var map = new google.maps.Map(document.getElementById('google-maps-hidden'), { mapTypeId: google.maps.MapTypeId.TERRAIN });
        //var coordenates = new google.maps.LatLng($scope.truck.latitud, $scope.truck.longitud);
        //var request = {
        //    location: coordenates,
        //    radius: 2000
        //};
        //var service = new google.maps.places.PlacesService(map);
        //service.nearbySearch(request, callback);
        //function callback(results, status) {
        //    var pepe = results.length;
        //}

        function drawPie() {
            var pieChart = AmCharts.makeChart($scope.truck.idTruck, {
                type: 'pie',
                startDuration: 0,
                theme: 'blur',
                addClassNames: true,
                color: '#209e91',
                labelTickColor: '#dfb81c',
                legend: {
                    enabled: false
                },
                innerRadius: '30%',
                defs: {
                    filter: [
                        {
                            id: 'shadow',
                            width: '200%',
                            height: '200%',
                            feOffset: {
                                result: 'offOut',
                                in: 'SourceAlpha',
                                dx: 0,
                                dy: 0
                            },
                            feGaussianBlur: {
                                result: 'blurOut',
                                in: 'offOut',
                                stdDeviation: 5
                            },
                            feBlend: {
                                in: 'SourceGraphic',
                                in2: 'blurOut',
                                mode: 'normal'
                            }
                        }
                    ]
                },
                dataProvider: graphData,
                valueField: 'level',
                titleField: 'label',
                export: {
                    enabled: true
                },
                creditsPosition: 'bottom-left',
                autoMargins: false,
                marginTop: 10,
                alpha: 0.7,
                marginBottom: 0,
                marginLeft: 0,
                pullOutRadius: 0,
                pathToImages: layoutPaths.images.amChart,
                responsive: {
                    enabled: true,
                    rules: [
                      {
                          maxWidth: 900,
                          overrides: {
                               valueAxes: {
                                  labelsEnabled: false
                              },
                              legend: {
                                  enabled: false
                              }
                          }
                      },
                      {
                          maxWidth: 200,
                          overrides: {
                              valueAxes: {
                                  labelsEnabled: false
                              },
                              marginTop: 30,
                              marginBottom: 30,
                              marginLeft: 30,
                              marginRight: 30
                          }
                      }
                    ]
                }
            });

            pieChart.addListener('init', handleInit);
            pieChart.addListener('rollOverSlice', function (e) {
                handleRollOver(e);
            });

            pieChart.invalidateSize();
        }

        function handleInit() {
            pieChart.legend.addListener('rollOverItem', handleRollOver);
        }

        function handleRollOver(e) {
            var wedge = e.dataItem.wedge.node;
            wedge.parentNode.appendChild(wedge);
        }

        $timeout(function () {
            //var inputs = document.getElementsByTagName("div");
            //for (var i = 0; i < inputs.length; i++) {
            //    console.log((inputs[i].id));
            //}
            drawPie();
        }, 10);
   
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.maps')
        .directive('googleMaps', googleMaps);

    /** @ngInject */
    function googleMaps() {
        return {
            restrict: 'E',
            controller: 'GoogleMapsCtrl',
            templateUrl: 'app/pages/maps/googleMaps/googleMaps.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.maps')
        .controller('GoogleMapsCtrl', GoogleMapsCtrl);

    /** @ngInject */
    function GoogleMapsCtrl($scope, $timeout, $rootScope, globalFactory, constantes, dataFactory) {
        function initialize() {
            globalFactory.setFromMsg(false);
            var datos = [];
            var placa;
            var activeMarker;
            var infoWindow = new google.maps.InfoWindow();

            var centerLat = 4.7;
            var centerLng = -74.7;

            getMapService();

            //LLamada al servicio GET desde el factory
            function getMapService() {
                dataFactory.getByItem()
                    .then(function (response) {
                        datos = [];
                        sortData(response);
                        setMap();

                        //Leer placa del vehiculo
                        //Tener en cuenta que se debe cargar primero dashboard
                        if (globalFactory.getVehiculos()[1] != undefined) {
                            placa = globalFactory.getVehiculos()[1][globalFactory.getItem() - 1].Placa;
                        }

                        //Si la llamada viene desde el calendario se devuelve al otro controlador
                        if (globalFactory.getFromMsg()) {
                            $rootScope.$broadcast('postService');
                        }
                    }, function (error) {
                        alert('No existen datos para la fecha seleccionada');
                        if (globalFactory.getFromMsg()) {
                            $rootScope.$broadcast('postService');
                        } else {
                            setMap();
                        } 
                    }); 
            }


            //LLamada al servicio GET desde el factory
            function getRangeService() {
                dataFactory.getByRange()
                    .then(function (response) {
                        datos = [];
                        sortData(response);
                        setMap();

                        //Leer placa del vehiculo
                        //Tener en cuenta que se debe cargar primero dashboard
                        if (globalFactory.getVehiculos()[1] != undefined) {
                            placa = globalFactory.getVehiculos()[1][globalFactory.getItem() - 1].Placa;
                        }

                        //Si la llamada viene desde el calendario se devuelve al otro controlador
                        if (globalFactory.getFromMsg()) {
                            $rootScope.$broadcast('postService');
                        }
                    }, function (error) {
                        alert('No existen datos para la fecha seleccionada');
                        if (globalFactory.getFromMsg()) {
                            $rootScope.$broadcast('postService');
                        } else {
                            setMap();
                        }
                    });
            }








            //Ordena los datos que se trae desde la llamada al servicio en el factory
            function sortData(response) {
                for (var i in response) {
                    if (response[i].Latitud !== null && response[i].Longitud !== null && response[i].Fecha !== null && response[i].Hora !== null && response[i].TanqueConductor != null && response[i].TanquePasajero !== null) {
                        datos.push({
                            lat: Number(response[i].Latitud),
                            lng: Number(response[i].Longitud),
                            Fecha: response[i].Fecha,
                            Hora: response[i].Hora,
                            Velocidad: response[i].Velocidad,
                            TanqueConductor: response[i].TanqueConductor,
                            TanquePasajero: response[i].TanquePasajero,
                            nivelTotal: (Number(response[i].TanqueConductor) + Number(response[i].TanquePasajero)).toFixed(1)
                        });
                    }
                }
                centerLat = datos[0].lat;
                centerLng = datos[0].lng;
                globalFactory.setDatos(datos);
            }

            //Plotea el mapa
            function setMap() {
                var mapCanvas = document.getElementById('google-maps');
                var mapOptions = {
                    center: new google.maps.LatLng(centerLat, centerLng),
                    zoom: 11,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                var map = new google.maps.Map(mapCanvas, mapOptions);
                var path = new google.maps.MVCArray();
                var service = new google.maps.DirectionsService();
                //aqui se pinta en el mapa
                var poly = new google.maps.Polyline({
                    path: datos,
                    //geodesic:true,
                    map: map,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                });
                if (globalFactory.getExistData()) {
                    var startMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(centerLat, centerLng),
                        map: map,
                        title: datos[0].Hora
                    });
                    setMarkers(map);
                }             
            }

            //Dibuja las marcas sobre el mapa
            function setMarkers(map) {
                for (var i = 0; i < datos.length; i++) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(datos[i].lat, datos[i].lng),
                        map: map,
                        //icon: constantes.greenDot
                    });
                    // switch para cambiar el color de los marcadores
                    if (datos[i].Velocidad == 0) {
                        marker.setIcon(constantes.blueDot);
                    } else if (datos[i].Velocidad >= 70 && datos[i].Velocidad < 100){
                        marker.setIcon(constantes.yellowDot);
                    } else if (datos[i].Velocidad >= 100) {
                        marker.setIcon(constantes.yellowDot);
                    } else {
                        marker.setIcon(constantes.greenDot);
                    }
                    (function (i, marker) {
                        google.maps.event.addListener(marker, 'click', function () {
                            if (!infoWindow) {
                                infoWindow = new google.maps.InfoWindow();
                            }
                            var contentHtml =
                            '<div id="content">' +
                              '<div id="siteNotice">' +
                              '</div>' +
                              '<h1 id="firstHeading" class="firstHeading" style="color:black">' + placa + '</h1>' +
                              '<div id="bodyContent" style="color:black">' +
                              '<p style="color:black">' + datos[i].Fecha + ' - ' + datos[i].Hora + '</p>' +
                              '<p style="color:black">Velocidad: ' + datos[i].Velocidad + '</p>' +
                              '<p style="color:black">Nivel Conductor: ' + datos[i].TanqueConductor + '</p>' +
                              '<p style="color:black">Nivel Pasajero: ' + datos[i].TanquePasajero + '</p>' +
                              '<p style="color:black">Nivel Total: ' + datos[i].nivelTotal + '</p>' +
                            '</div>';
                            infoWindow.setContent(contentHtml);
                            infoWindow.open(map, marker);

                            // check to see if activeMarker is set
                            // if so, set the icon back to the default
                            activeMarker && activeMarker.setIcon(constantes.greenDot);

                            // set the icon for the clicked marker
                            marker.setIcon(constantes.redCar);

                            // update the value of activeMarker
                            activeMarker = marker;

                            //LLamada a evento de controlador externo y setear variable global
                            var gaugesData = [datos[i].Velocidad, datos[i].TanqueConductor, datos[i].TanquePasajero];
                            $rootScope.$broadcast('markerClick', gaugesData);

                        });
                    })(i, marker);
                }
            }

            //Listener del broadcast desde msgCtrl
            $scope.$on('mapClick', function (event) {
                getMapService();
            });

            //Listener del broadcast desde msgCtrl del rango
            $scope.$on('mapRangeClick', function (event) {
                getRangeService();
            });
        }

        $timeout(function () {
            initialize();
        }, 100);
    }

})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.maps')
        .directive('infoMaps', infoMaps);

    /** @ngInject */
    function infoMaps() {
        return {
            restrict: 'E',
            controller: 'InfoMapsCtrl',
            templateUrl: 'app/pages/maps/infoMaps/infoMaps.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.maps')
        .controller('InfoMapsCtrl', InfoMapsCtrl);

    /** @ngInject */
    function InfoMapsCtrl($timeout, $http, $scope, globalFactory) {
        function initialize() {
            var datos = [];
            var gaugeChart;
            var gaugeFuelChart1;
            var gaugeFuelChart2;
            var gaugesData;

            drawSpeedGauge();
            drawFuelGauge1();
            drawFuelGauge2();


            if (globalFactory.getDatos().length > 0) {
                datos = globalFactory.getDatos();
                var index = datos.length - 1;
                gaugesData = [datos[index].Velocidad, datos[index].TanqueConductor, datos[index].TanquePasajero];
            } else {
                gaugesData = [0, 0, 0];
            }

            setSpeedValue(gaugesData);
            setFuelValue1(gaugesData);
            setFuelValue2(gaugesData);
            
            
            function drawSpeedGauge() {
                gaugeChart = AmCharts.makeChart('speed-gauge', {
                    "type": "gauge",
                    "marginBottom": 0,
                    "marginTop": 0,
                    "theme": "light",
                    "axes": [{
                        "axisThickness": 1,
                        "axisAlpha": 0.2,
                        "tickAlpha": 0.8,
                        "valueInterval": 10,
                        "bands": [{
                            "color": "#84b761",
                            "endValue": 120,
                            "startValue": 80
                        }, {
                            "color": "#fdd400",
                            "endValue": 80,
                            "startValue": 40
                        }, {
                            "color": "#cc4748",
                            "endValue": 40,
                            "startValue": 0
                        }],
                        "bottomText": "0 Km/h",
                        "bottomTextYOffset": -10,
                        "endValue": 120
                    }],
                    "arrows": [{
                        //"value": datos[index].Velocidad
                    }],
                    "export": {
                        "enabled": true
                    }
                });
                //setInterval(randomValue, 2000);
                //setGaugeValue();
            }

            function drawFuelGauge1() {
                gaugeFuelChart1 = AmCharts.makeChart('fuel-gauge1', {
                    "type": "gauge",
                    "marginBottom": 0,
                    "marginTop": 0,
                    "theme": "light",
                    "axes": [{
                        "labelsEnabled": false,
                        "startAngle": -45,
                        "endAngle": 45,
                        "axisThickness": 1,
                        "axisAlpha": 0.2,
                        "tickAlpha": 0.8,
                        "valueInterval": 40,
                        "bands": [{
                            "color": "#cc4748",
                            "endValue": 40,
                            "startValue": 0,
                            "innerRadius": "90%",
                        }, {
                            "color": "#ffffff",
                            "endValue": 120,
                            "startValue": 40
                        }],
                        "bottomText": "0 Gal",
                        "bottomTextYOffset": -20,
                        "endValue": 120
                    }],
                    "arrows": [{
		                "alpha": 1,
		                "borderAlpha": 0,
		                "color": "#FF8000",
		                "nailAlpha": 0,
		                "id": "GaugeArrow-1",
		                "innerRadius": 0,   
		                "startWidth": 5,
		                //"value": datos[index].TanqueConductor
		                }],
                    "export": {
                        "enabled": true
                    }
                });

                //if (gaugeFuelChart) {
                //    if (gaugeFuelChart.arrows) {
                //        if (gaugeFuelChart.arrows[0]) {
                //            if (gaugeFuelChart.arrows[0].setValue) {
                //                gaugeFuelChart.arrows[0].setValue(datos[index].nivel1);
                //                gaugeFuelChart.axes[0].setBottomText(datos[index].nivel1 + " Gal");
                //            }
                //        }
                //    }
                //}
            }

            function drawFuelGauge2() {
                gaugeFuelChart2 = AmCharts.makeChart('fuel-gauge2', {
                    "type": "gauge",
                    "marginBottom": 0,
                    "marginTop": 0,
                    "theme": "light",
                    "axes": [{
                        "labelsEnabled": false,
                        "startAngle": -45,
                        "endAngle": 45,
                        "axisThickness": 1,
                        "axisAlpha": 0.2,
                        "tickAlpha": 0.8,
                        "valueInterval": 40,
                        "bands": [{
                            "color": "#cc4748",
                            "endValue": 40,
                            "startValue": 0,
                            "innerRadius": "90%",
                        }, {
                            "color": "#ffffff",
                            "endValue": 120,
                            "startValue": 40
                        }],
                        "bottomText": "0 Gal",
                        "bottomTextYOffset": -20,
                        "endValue": 120
                    }],
                    "arrows": [{
                        "alpha": 1,
                        "borderAlpha": 0,
                        "color": "#FF8000",
                        "nailAlpha": 0,
                        "id": "GaugeArrow-2",
                        "innerRadius": 0,
                        "startWidth": 5,
                        //"value": datos[index].TanquePasajero
                    }],
                    "export": {
                        "enabled": true
                    }
                });
            }

            $scope.$on('markerClick', function (event, arg) {
                if (arg != null){
                    setSpeedValue(arg);
                    setFuelValue1(arg);
                    setFuelValue2(arg);
                }
            });

            // set value
            function setSpeedValue(gaugesData) {
                if (gaugeChart) {
                    if (gaugeChart.arrows) {
                        if (gaugeChart.arrows[0]) {
                            if (gaugeChart.arrows[0].setValue) {
                                gaugeChart.arrows[0].setValue(gaugesData[0]);
                                gaugeChart.axes[0].setBottomText(gaugesData[0] + " Km/h");
                            }
                        }
                    }
                }
            }
            function setFuelValue1(gaugesData) {
                if (gaugeFuelChart1) {
                    if (gaugeFuelChart1.arrows) {
                        if (gaugeFuelChart1.arrows[0]) {
                            if (gaugeFuelChart1.arrows[0].setValue) {
                                gaugeFuelChart1.arrows[0].setValue(gaugesData[1]);
                                gaugeFuelChart1.axes[0].setBottomText(gaugesData[1] + " Gal");
                            }
                        }
                    }
                }
            }
            function setFuelValue2(gaugesData) {
                if (gaugeFuelChart2) {
                    if (gaugeFuelChart2.arrows) {
                        if (gaugeFuelChart2.arrows[0]) {
                            if (gaugeFuelChart2.arrows[0].setValue) {
                console.log(gaugesData);
                                gaugeFuelChart2.arrows[0].setValue(gaugesData[2]);
                                gaugeFuelChart2.axes[0].setBottomText(gaugesData[2] + " Gal");
                            }
                        }
                    }
                }
            }

        }
        
        $timeout(function () {
            initialize();
        }, 1000);
    }

})();

/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.tables')
        .directive('smartTable', smartTable);

    /** @ngInject */
    function smartTable() {
        return {
            restrict: 'E',
            controller: 'SmartTableCtrl',
            templateUrl: 'app/pages/tables/smart/smartTable.html'
        };
    }
})();
/**
 * @author c.polania
 * created on 13.08.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('SmartTableCtrl', SmartTableCtrl);

  /** @ngInject */
  function SmartTableCtrl($scope, $rootScope, $filter, $timeout, editableOptions, editableThemes, globalFactory, dataFactory) {
      function initialize() {
          globalFactory.setFromMsg(false);
          var datos = [];
          $scope.smartTablePageSize = 20;
          getTableService();

          //LLamada al serrvicio GET desde el factory
          function getTableService() {
              dataFactory.getByItem()
                  .then(function (response) {
                      datos = [];
                      sortData(response);
                      //Si a llamada viene desde el calendario se devuelve al otro controlador
                      if (globalFactory.getFromMsg()) {
                          $rootScope.$broadcast('postService');
                      }
                  }, function (error) {
                      alert('No existen datos para la fecha seleccionada');
                      if (globalFactory.getFromMsg()) {
                          $rootScope.$broadcast('postService');
                      }
                  });
          }

          //Ordena los datos que se trae desde la llamada al servicio en el factory
          function sortData(response) {
              for (var i in response) {
                  if (response[i].Latitud !== null && response[i].Longitud !== null && response[i].Fecha !== null && response[i].Hora !== null && response[i].TanqueConductor != null && response[i].TanquePasajero !== null) {
                      datos.push({
                          lat: Number(response[i].Latitud),
                          lng: Number(response[i].Longitud),
                          Fecha: response[i].Fecha,
                          Hora: response[i].Hora,
                          Velocidad: response[i].Velocidad,
                          TanqueConductor: response[i].TanqueConductor,
                          TanquePasajero: response[i].TanquePasajero,
                          nivelTotal: (Number(response[i].TanqueConductor) + Number(response[i].TanquePasajero)).toFixed(1)
                      });
                  }
              }
              
              $scope.smartTableData = datos;
              globalFactory.setDatos(datos);
          }

          //Listener del broadcast desde msgCtrl
          $scope.$on('tableClick', function (event) {
              getTableService();
          });
      }
      
        $scope.showGroup = function (user) {
        if (user.group && $scope.groups.length) {
            var selected = $filter('filter')($scope.groups, { id: user.group });
            return selected.length ? selected[0].text : 'Not set';
        } else return 'Not set'
        };

        $scope.showStatus = function (user) {
        var selected = [];
        if (user.status) {
            selected = $filter('filter')($scope.statuses, { value: user.status });
        }
        return selected.length ? selected[0].text : 'Not set';
        };


        //$scope.removeUser = function (index) {
        //    $scope.users.splice(index, 1);
        //};

        //$scope.addUser = function () {
        //    $scope.inserted = {
        //        id: $scope.users.length + 1,
        //        name: '',
        //        status: null,
        //        group: null
        //    };
        //    $scope.users.push($scope.inserted);
        //};

        //editableOptions.theme = 'bs3';
        //editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        //editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';   


      $timeout(function () {
          initialize();
      }, 100);

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('contentTop', contentTop);

    /** @ngInject */
    function contentTop($location, $state, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/contentTop/contentTop.html',
            link: function ($scope) {
                $scope.$watch(function () {
                    $scope.activePageTitle = $state.current.title;
                    if ($state.current.title == "Dashboard") {
                        $rootScope.isVisible = false;
                        $rootScope.showBtnTruck = true;
                    } else {
                        $rootScope.isVisible = true;
                        $rootScope.showBtnTruck = true;
                    }
                    //if ($state.current.title == "Combustible" || $state.current.title == "Desplazamiento") {
                    //    $scope.activePageTitle = "Placa seleccionada";
                    //}
                    //if ($state.current.title == "Admin") {
                    //    $rootScope.showMobileSelector = true;
                    //    $rootScope.showBtnTruck = false;
                    //} else {
                    //    $rootScope.showMobileSelector = true;
                    //    $rootScope.showBtnTruck = true;
                    //    $rootScope.isVisible = true;
                    //}
                });
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author c.polania
 * created on 23.07.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('MsgCenterCtrl', MsgCenterCtrl);

    /** @ngInject */
    function MsgCenterCtrl($http, $timeout, $scope, $rootScope, $window, $sce, $state, globalFactory, baConfig, $element, layoutPaths, dataFactory) {
        function initialize() {

            $scope.names = ["Emil", "Tobias", "Linus"];

            $scope.users = {
                0: {
                    name: 'Vlad',
                },
                1: {
                    name: 'Kostya',
                },
                2: {
                    name: 'Andrey',
                },
                3: {
                    name: 'Nasta',
                }
            };

            $scope.notifications = [
                {
                    userId: 0,
                    template: '&name posted a new article.',
                    time: '1 min ago'
                },
                {
                    userId: 1,
                    template: '&name changed his contact information.',
                    time: '2 hrs ago'
                },
                {
                    image: 'assets/img/shopping-cart.svg',
                    template: 'New orders received.',
                    time: '5 hrs ago'
                },
                {
                    userId: 2,
                    template: '&name replied to your comment.',
                    time: '1 day ago'
                },
                {
                    userId: 3,
                    template: 'Today is &name\'s birthday.',
                    time: '2 days ago'
                },
                {
                    image: 'assets/img/comments.svg',
                    template: 'New comments on your post.',
                    time: '3 days ago'
                },
                {
                    userId: 1,
                    template: '&name invited you to join the event.',
                    time: '1 week ago'
                }
            ];

            $scope.messages = [
                {
                    userId: 3,
                    text: 'After you get up and running, you can place Font Awesome icons just about...',
                    time: '1 min ago'
                },
                {
                    userId: 0,
                    text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
                    time: '2 hrs ago'
                },
                {
                    userId: 1,
                    text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
                    time: '10 hrs ago'
                },
                {
                    userId: 2,
                    text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
                    time: '1 day ago'
                },
                {
                    userId: 3,
                    text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
                    time: '1 day ago'
                },
                {
                    userId: 1,
                    text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
                    time: '2 days ago'
                },
                {
                    userId: 0,
                    text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
                    time: '1 week ago'
                }
            ];

            $scope.getMessage = function (msg) {
                var text = msg.template;
                if (msg.userId || msg.userId === 0) {
                    text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
                }
                return $sce.trustAsHtml(text);
            };

            
            $scope.vehiculos;
            getItems();

            //Obtiene los items para poblar la lista
            function getItems() {
                dataFactory.getItemsByUser()
                    .then(function (response) {
                        globalFactory.setVehiculos(response);
                        $scope.vehiculos = globalFactory.getVehiculos();
                    }, function (error) {
                        $scope.status = 'Unable to load customer data: ' + error.message;
                    });
            }

            

            //aqui van los metodos del calendario, el camion y la lista de moviles
            //$scope.vehiculos = globalFactory.getVehiculos();
            //$scope.vehiculos = $scope.vehiculos[1];

            
            //$scope.labelPlaca = globalFactory.getVehiculos()[1][globalFactory.getItem() - 1].Placa;

            //Rutina para almacenamiento de fecha en variable global
            $scope.dateLabel = globalFactory.getDate();
            $scope.itemSelected = globalFactory.getItem();

            //Rutina para enviar al controlador segun la pagina seleccion item
            $scope.selectItem = function (item) {
                globalFactory.setItem(item.IdItem);
                console.log('item ' + globalFactory.getItem());
                globalFactory.setFromMsg(true);
                if ($state.current.title == "Mapa") {
                    $rootScope.$broadcast('mapClick');
                } if ($state.current.title == "Graficas") {
                    $rootScope.$broadcast('chartClick');
                } else if ($state.current.title == "Tablas") {
                    $rootScope.$broadcast('tableClick');
                }
            };

            //Rutina para enviar al controlador segun la pagina seleccion fecha
            $scope.select = function (date) {
                globalFactory.setDate(formatDate(date));
                console.log('item ' + globalFactory.getItem());
                globalFactory.setFromMsg(true);
                if ($state.current.title == "Mapa") {
                    $rootScope.$broadcast('mapClick');
                } if ($state.current.title == "Graficas") {
                    $rootScope.$broadcast('chartClick');
                } else if ($state.current.title == "Tablas") {
                    $rootScope.$broadcast('tableClick');
                }
            };

            //Rutina que se ejecuta luego de la llamada al servicio y presentacion de datos
            $scope.$on('postService', function (event) {
                if (globalFactory.getExistData()) {
                    $scope.dateLabel = globalFactory.getDate();
                    $scope.itemSelected = globalFactory.getItem();
                } else {
                    //globalFactory.setDate($scope.dateLabel);
                    //globalFactory.setItem($scope.itemSelected);
                    var fecha = new Date(globalFactory.getDate());
                    $scope.selectedDate = fecha.setDate(fecha.getDate() + 1);
                }
            });

            $scope.dtpOptions = {
                showWeeks: false
            };

            //Rutina para abrir el calendario
            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = true;
            };







            var start = moment().subtract(29, 'days');
            var end = moment();

            function cb(start, end) {
                $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
            }

            $('#reportrange').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    'Hoy': [moment(), moment()],
                    'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Ultimos 7 dias': [moment().subtract(6, 'days'), moment()],
                    'Ultimos 30 dias': [moment().subtract(29, 'days'), moment()],
                    'Este Mes': [moment().startOf('month'), moment().endOf('month')],
                    'Mes Anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            }, cb);

            cb(start, end);

            $('#reportrange').on('apply.daterangepicker', function (ev, picker) {
                //do something, like clearing an input
                globalFactory.setDate(picker.startDate.format('YYYY-MM-DD'));
                globalFactory.setFinalDate(picker.endDate.format('YYYY-MM-DD'));
                console.log(globalFactory.getDate() + ' - ' + globalFactory.getFinalDate() + ' - ' + globalFactory.getItem());

                globalFactory.setFromMsg(true);
                if ($state.current.title == "Mapa") {
                    $rootScope.$broadcast('mapRangeClick');
                } if ($state.current.title == "Graficas") {
                    $rootScope.$broadcast('chartRangeClick');
                } else if ($state.current.title == "Tablas") {
                    $rootScope.$broadcast('tableClick');
                }
            });

        }
            

        $timeout(function () {
            initialize();
        }, 10);

    }
    

    //Formatea de un string a date
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/charts/charts.html','<div class="widgets"><div class="col-lg-12 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><line-chart></line-chart></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><dashboard-map></dashboard-map></div></div><hr><a class="clearfix" ng-repeat="truck in info[1]"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-title="{{truck.plate}}" ba-panel-class="medium-panel traffic-panel"><div class="row"><div class="col-lg-3 col-md-3 col-sm-6"><dashboard-block log="truck"></dashboard-block></div><div class="col-lg-6 col-md-6 col-sm-6"><dashboard-pie-chart></dashboard-pie-chart></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><dashboard-fuel-gauge log="truck"></dashboard-fuel-gauge></div><div class="col-lg-3 col-md-6 col-sm-6"><dashboard-speed-gauge log="truck"></dashboard-speed-gauge></div></div></div></div></a>');
$templateCache.put('app/pages/maps/maps.html','<div class="row"><div class="col-lg-8 col-md-8 col-sm-12" ba-panel="" ba-panel-title="Mapa" ba-panel-class="medium-panel"><google-maps></google-maps></div><div class="col-lg-4 col-md-4 col-sm-12" ba-panel="" ba-panel-title="Informacion" {{globalfactory.getvehiculos()[1][globalfactory.getitem()="" -="" 1].placa}}="" ba-panel-class="medium-panel"><info-maps></info-maps></div></div>');
$templateCache.put('app/pages/tables/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Registro de datos diario" ba-panel-class="with-scroll"><smart-table></smart-table></div></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown="" ng-show="showBtnTruck"><a href="" uib-dropdown-toggle=""><i class="fa fa-truck"></i><span>{{vehiculos.length}}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="msg-list"><a href="" class="clearfix" ng-repeat="item in vehiculos" ng-click="selectItem(item)"><div class="msg-area"><div><strong>{{ item.Informacion }}</strong></div><span>{{ item.Placa }}</span></div></a></div></div></li><li uib-dropdown=""><div id="reportrange" class="pull-right" style="background: #000; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i>&nbsp; <span></span> <b class="caret"></b></div></li><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a target="_blank" href="http://coreiot.azurewebsites.net/" class="al-logo hidden-xs"><span>Core</span>IoT</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search"><i class="ion-ios-search-strong" ng-click="startSearch()"></i> <input id="searchInput" type="text" placeholder="Search for..."></div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'core\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/profile"><i class="fa fa-user"></i>Profile</a></li><li><a href=""><i class="fa fa-cog"></i>Settings</a></li><li><a href="" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/charts/lineChart/lineChart.html','<div id="lineChart1" class="admin-chart"></div><hr><div id="lineChart2" class="admin-chart"></div>');
$templateCache.put('app/pages/dashboard/dashboardBlock/dashboardBlock.html','<div ba-panel=""><div class="labels-block"><label>Tipo: {{truck.Informacion}}</label><br><label>Fecha: {{truck.Fecha}}</label><br><label>Hora: {{truck.Hora}}</label><br><label>Ubicacion:</label><br></div></div>');
$templateCache.put('app/pages/dashboard/dashboardFuelGauge/dashboardFuelGauge.html','<div class="row"><div class="col-xs-6"><div ba-panel=""><div id="{{\'object1-\' + truck.IdItem}}" class="traffic-chart"></div></div></div><div class="col-xs-6"><div ba-panel=""><div id="{{\'object2-\' + truck.IdItem}}" class="traffic-chart"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container-dashboard col-xs-6" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="{{::chart.percent}}"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardSpeedGauge/dashboardSpeedGauge.html','<div class="row"><div ba-panel=""><div id="{{truck.IdItem}}" class="traffic-chart"></div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div id="{{truck.idTruck}}" class="traffic-chart"></div></div>');
$templateCache.put('app/pages/maps/googleMaps/googleMaps.html','<div id="google-maps"></div>');
$templateCache.put('app/pages/maps/infoMaps/infoMaps.html','<div class="row"><div id="speed-gauge" class="traffic-chart"></div></div><div class="row"><div id="fuel-gauge1" class="traffic-chart"></div><div id="fuel-gauge2" class="traffic-chart"></div></div>');
$templateCache.put('app/pages/tables/smart/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th st-sort="Hora" st-sort-default="true">Hora</th><th st-sort="lat">Latitud</th><th st-sort="lng">Longitud</th><th st-sort="TanqueConductor">Nivel Conductor</th><th st-sort="TanquePasajero">Nivel Pasajero</th><th st-sort="nivelTotal">Nivel Total</th><th st-sort="Velocidad">Velocidad</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td>{{item.Hora}}</td><td>{{item.lat}}</td><td>{{item.lng}}</td><td>{{item.TanqueConductor}}</td><td>{{item.TanquePasajero}}</td><td>{{item.nivelTotal}}</td><td>{{item.Velocidad}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="20"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');}]);